import { AchievementInfo } from "./AchievementInfoTypes";

// -----
// *** SET ACHIEVEMENTS ***
// -----

// Alpha Team Cruiser (6772-1)
export const Achievement_Set_6772_1: AchievementInfo = {
  id: "achievement_set_6772-1_1",
  title: "Alpha Team Owner",
  description: "Purchase 10 Alpha Team Cruiser sets",
  category: "set",
  targetType: "specific",
  targetId: "6772-1",
  threshold: 10,
};

export const Achievement_Set_6772_10: AchievementInfo = {
  id: "achievement_set_6772-1_10",
  title: "Alpha Team Collector",
  description: "Purchase 1,000 Alpha Team Cruiser sets",
  category: "set",
  targetType: "specific",
  targetId: "6772-1",
  threshold: 1000,
};

// Tahu (8534-1)
export const Achievement_Set_8534_1: AchievementInfo = {
  id: "achievement_set_8534-1_1",
  title: "Tahu Owner",
  description: "Purchase 10 Tahu sets",
  category: "set",
  targetType: "specific",
  targetId: "8534-1",
  threshold: 10,
};

export const Achievement_Set_8534_10: AchievementInfo = {
  id: "achievement_set_8534-1_10",
  title: "Tahu Collector",
  description: "Purchase 1,000 Tahu sets",
  category: "set",
  targetType: "specific",
  targetId: "8534-1",
  threshold: 1000,
};

// The Knight Bus (4866-1)
export const Achievement_Set_4866_1: AchievementInfo = {
  id: "achievement_set_4866-1_1",
  title: "Knight Bus Owner",
  description: "Purchase 10 The Knight Bus sets",
  category: "set",
  targetType: "specific",
  targetId: "4866-1",
  threshold: 10,
};

export const Achievement_Set_4866_10: AchievementInfo = {
  id: "achievement_set_4866-1_10",
  title: "Knight Bus Collector",
  description: "Purchase 1,000 The Knight Bus sets",
  category: "set",
  targetType: "specific",
  targetId: "4866-1",
  threshold: 1000,
};

// Garbage Truck (4432-1)
export const Achievement_Set_4432_1: AchievementInfo = {
  id: "achievement_set_4432-1_1",
  title: "Garbage Truck Owner",
  description: "Purchase 10 Garbage Truck sets",
  category: "set",
  targetType: "specific",
  targetId: "4432-1",
  threshold: 10,
};

export const Achievement_Set_4432_10: AchievementInfo = {
  id: "achievement_set_4432-1_10",
  title: "Garbage Truck Collector",
  description: "Purchase 1,000 Garbage Truck sets",
  category: "set",
  targetType: "specific",
  targetId: "4432-1",
  threshold: 1000,
};

// TIE Fighter (7146-1)
export const Achievement_Set_7146_1: AchievementInfo = {
  id: "achievement_set_7146-1_1",
  title: "TIE Fighter Owner",
  description: "Purchase 10 TIE Fighter sets",
  category: "set",
  targetType: "specific",
  targetId: "7146-1",
  threshold: 10,
};

export const Achievement_Set_7146_10: AchievementInfo = {
  id: "achievement_set_7146-1_10",
  title: "TIE Fighter Collector",
  description: "Purchase 1,000 TIE Fighter sets",
  category: "set",
  targetType: "specific",
  targetId: "7146-1",
  threshold: 1000,
};

// Lloyd's Legendary Dragon (71766-1)
export const Achievement_Set_71766_1: AchievementInfo = {
  id: "achievement_set_71766-1_1",
  title: "Legendary Dragon Owner",
  description: "Purchase 10 Lloyd's Legendary Dragon sets",
  category: "set",
  targetType: "specific",
  targetId: "71766-1",
  threshold: 10,
};

export const Achievement_Set_71766_10: AchievementInfo = {
  id: "achievement_set_71766-1_10",
  title: "Legendary Dragon Collector",
  description: "Purchase 1,000 Lloyd's Legendary Dragon sets",
  category: "set",
  targetType: "specific",
  targetId: "71766-1",
  threshold: 1000,
};

// Himeji Castle (21060-1)
export const Achievement_Set_21060_1: AchievementInfo = {
  id: "achievement_set_21060-1_1",
  title: "Himeji Castle Owner",
  description: "Purchase 10 Himeji Castle sets",
  category: "set",
  targetType: "specific",
  targetId: "21060-1",
  threshold: 10,
};

export const Achievement_Set_21060_10: AchievementInfo = {
  id: "achievement_set_21060-1_10",
  title: "Himeji Castle Collector",
  description: "Purchase 1,000 Himeji Castle sets",
  category: "set",
  targetType: "specific",
  targetId: "21060-1",
  threshold: 1000,
};

// Lion Knights' Castle (10305-1)
export const Achievement_Set_10305_1: AchievementInfo = {
  id: "achievement_set_10305-1_1",
  title: "Lion Knights' Castle Owner",
  description: "Purchase 10 Lion Knights' Castle sets",
  category: "set",
  targetType: "specific",
  targetId: "10305-1",
  threshold: 10,
};

export const Achievement_Set_10305_10: AchievementInfo = {
  id: "achievement_set_10305-1_10",
  title: "Lion Knights' Castle Collector",
  description: "Purchase 1,000 Lion Knights' Castle sets",
  category: "set",
  targetType: "specific",
  targetId: "10305-1",
  threshold: 1000,
};

// Millennium Falcon (10179-1)
export const Achievement_Set_10179_1: AchievementInfo = {
  id: "achievement_set_10179-1_1",
  title: "Millennium Falcon Owner",
  description: "Purchase 10 Millennium Falcon sets",
  category: "set",
  targetType: "specific",
  targetId: "10179-1",
  threshold: 10,
};

export const Achievement_Set_10179_10: AchievementInfo = {
  id: "achievement_set_10179-1_10",
  title: "Millennium Falcon Collector",
  description: "Purchase 1,000 Millennium Falcon sets",
  category: "set",
  targetType: "specific",
  targetId: "10179-1",
  threshold: 1000,
};

// Eiffel Tower (10307-1)
export const Achievement_Set_10307_1: AchievementInfo = {
  id: "achievement_set_10307-1_1",
  title: "Eiffel Tower Owner",
  description: "Purchase 10 Eiffel Tower sets",
  category: "set",
  targetType: "specific",
  targetId: "10307-1",
  threshold: 10,
};

export const Achievement_Set_10307_10: AchievementInfo = {
  id: "achievement_set_10307-1_10",
  title: "Eiffel Tower Collector",
  description: "Purchase 1,000 Eiffel Tower sets",
  category: "set",
  targetType: "specific",
  targetId: "10307-1",
  threshold: 1000,
};
